import React from 'react';
import { Container, MockupPhone, ContainerPreview } from './MobilePreview.styles';
import PhoneImage from '../../../../assets/images/mockup-smartphone.png';
import { Preview } from '../Preview';

export function MobilePreview(): JSX.Element {
  return (
    <Container>
      <ContainerPreview>
        <Preview />
      </ContainerPreview>
      <MockupPhone src={PhoneImage} />
    </Container>
  );
}
